import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { TermsContent } from './TermsContent';
import { PrivacyContent } from './PrivacyContent';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-burgundy-950 text-burgundy-200 py-12 px-4 border-t border-burgundy-900" data-id="element-2">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-3">
          <div className="text-center md:text-left" data-id="element-4">
            <h3 className="font-serif text-xl text-white mb-2" data-id="element-5">
              7 Noches Para Volver a Tocarnos
            </h3>
            <p className="text-sm opacity-60" data-id="element-6">Una guía para parejas reales.</p>
          </div>

          <div className="flex gap-6 text-sm opacity-60" data-id="element-7">
            <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-8">
              Términos
            </button>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-9">
              Privacidad
            </button>
          </div>

          <div className="text-xs opacity-40" data-id="element-10">
            © {new Date().getFullYear()} María Dohgrato. Todos los derechos
            reservados.
          </div>
        </div>
      </footer>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-11">
        <TermsContent data-id="element-12" />
      </Modal>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-13">
        <PrivacyContent data-id="element-14" />
      </Modal>
    </>;
}